<template>
  <div class="">
    <search-group title="" @search="findData" @clear="clearValue">
      <Row :gutter="16">
        <Col span="5">
          <Input class="block" v-model="searchData.userInfo" placeholder="用户名或Code" @keyup.enter.native="findData" />
        </Col>
        <Col span="5">
          <Input class="block" v-model="searchData.operation" placeholder="操作名称" @keyup.enter.native="findData" />
        </Col>
        <Col span="6">
          <DatePicker class="block" type="daterange" :editable=false split-panels placeholder="创建日期范围" v-model="createDate" @on-change="getCreateDate"></DatePicker>
        </Col>
      </Row>
    </search-group>
  </div>
</template>

<script>
// import SearchGroup from "components/SearchGroup/index";

export default {
  // name: "SearchList",
  components: {
    // SearchGroup
  },
  data() {
    return {
      createDate: [],
      searchData: {
        userInfo:'' ,
        operation: '',
        createTimeFrom: '',
        createTimeTo: '',
      }
    };
  },
  methods: {
    findData() {
      this.$emit("findData", this.searchData);
    },
    clearValue() {
      this.createDate= []
      this.searchData= {
        userInfo:'' ,
        operation: '',
        createTimeFrom: '',
        createTimeTo: '',
      }
    },
    getCreateDate(val){
      this.searchData.createTimeFrom = val[0]
      this.searchData.createTimeTo = val[1]
    },
  },
  created() {
    this.$emit('findData',this.searchData)
  }
};
</script>
<style scoped>
  .flex {
    display: block;
  }
  .search-wrapper {
    padding: 24px 0 !important;
  }

  .shortcut a {
    display: inline-block;
    padding: 10px 20px;
    font-weight: bold;
    color: #444444;
  }

  .width200 {
    width: 200px;
  }

  .width300 {
    width: 300px;
  }

  .block {
    display: block;
  }
</style>
